const LobbyClient = {
  Id: 5,
  masterCategory: {
    Web: "Web",
    Mobile: "Mobile",
  },
};

export default LobbyClient;
